import { useTranslation } from 'react-i18next';
import { PurchasePrice } from '../api/_generated_';

const STRONG_COLUMNS = [
  'productId',
  'productName',
  'currentPurchasePrice',
  'depositInfoCode',
  'futurePrice',
  'currentRetailPrice',
  'purchasePrice',
  'retailPrice',
  'calculatePrice',
];

export default function usePurchasePriceColumns() {
  const { t } = useTranslation();

  function filterColumns(field: string) {
    return STRONG_COLUMNS.includes(field);
  }

  function toExcelColumn(item: PurchasePrice) {
    return {
      ID: item.productId,
      [t('common.label-name')]: item.productName,
      [t('purchase-prices.label-current-purchase-price')]: item.currentPurchasePrice,
      [t('purchase-prices.label-current-retail-price')]: item.currentRetailPrice,
      [t('purchase-prices.label-purchase-price')]: item.purchasePrice,
      [t('purchase-prices.label-retail-price')]: item.retailPrice,
      [t('purchase-prices.label-deposit-info')]: item.depositInfoCode,
    };
  }

  return {
    filterColumns,
    toExcelColumn,
  };
}
